import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { get } from 'scriptjs';
import { decrypt } from 'src/app/helpers/crypt.helper';
import { AuthResult } from 'src/app/models/auth-result.model';
import { Plano } from 'src/app/models/plano.model';
import { Proposta } from 'src/app/models/proposta.model';
import { SDKResponse } from 'src/app/models/sdk-response.model';
import { Simulacao } from 'src/app/models/simulacao.model';

import { AppStateService } from 'src/app/services/app-state.service';
import { CepService } from 'src/app/services/cep.service';
import { CreditoService } from 'src/app/services/credito.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-simulation',
  templateUrl: './simulation.component.html',
  styleUrls: ['./simulation.component.scss']
})
export class SimulationComponent implements OnInit {

  formDocumentos: FormGroup;
  formEndereco: FormGroup;
  formDadosBancarios: FormGroup;

  simulacao: Simulacao;
  planoSelecionado: Plano;
  authResult: AuthResult;
  step: number = 0;

  constructor(
    private appState: AppStateService,
    private router: Router,
    private formBuilder: FormBuilder,
    private credito: CreditoService,
    private cepService: CepService,
    private location: Location) {
    this.formDocumentos = this.formBuilder.group({
      estCivil: ['', [Validators.required]],
      escolaridade: ['', [Validators.required]],
      telefone: ['', [Validators.required]],
      dddCel1: [''],
      foneCel1: [''],
    });

    this.formEndereco = this.formBuilder.group({
      logradouro: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      complemento: [''],
      bairro: ['', [Validators.required]],
      localidade: ['', [Validators.required]],
      uf: ['', [Validators.required]],
      cep: ['', [Validators.required]],
    });

    this.formDadosBancarios = this.formBuilder.group({
      numeroConta: [null, []],
      codigoBanco: [null, []],
      codigoAgencia: [null, []],
      digitoAgencia: [null, []],
      digitoConta: [null, []],
    });
  }

  ngOnInit() {
    this.getAuthResult();
    this.getSimulacao();
  }

  getAuthResult() {
    this.appState.getAuthResult.subscribe(authResult => {
      // console.log('authResult => ', authResult);
      this.authResult = authResult;
      this.preencheTelefone();
    });
  }

  preencheTelefone() {
    if (this.authResult.ddd && this.authResult.fone) {
      this.formDocumentos.controls['telefone'].setValue(`${this.authResult.cliente.dddCel1}${this.authResult.cliente.foneCel1}`);
    }
  }

  preencheEndereco() {
    this.formEndereco.patchValue(this.authResult.cliente);
  }

  getSimulacao() {
    this.appState.getSimulacao.subscribe(simulacao => {
      this.simulacao = simulacao;
      this.planoSelecionado = simulacao.planos.filter(p => p['selecionado'])[0];
    });
  }

  getPayload() {
    if (this.formDocumentos.valid) {
      const telefone: string = this.formDocumentos.get('telefone').value;
      const telefoneArr = telefone.split('');
      let ddd = '';
      let fone = '';
      telefoneArr.forEach((caractere, index) => { if (index === 0 || index === 1) { ddd += caractere; } else { fone += caractere; } })

      this.formDocumentos.get('dddCel1').setValue(ddd);
      this.formDocumentos.get('foneCel1').setValue(fone);

      const payload: Proposta = {
        // dtFin: this.simulacao.dtFin,
        // dtVenc1: this.simulacao.dtVenc1,
        // iof: this.planoSelecionado.iof,
        // tc: this.planoSelecionado.tc,
        // vrFin: this.planoSelecionado.vrFin,
        // item: this.authResult.itens,
        prestacao: this.planoSelecionado.prestacao,
        plano: this.planoSelecionado.plano,
        cliente: {
          estCivil: this.formDocumentos.get('estCivil').value,
          escolaridade: this.formDocumentos.get('escolaridade').value,
          dddCel1: this.formDocumentos.get('dddCel1').value,
          foneCel1: this.formDocumentos.get('foneCel1').value,
          logradouro: this.formEndereco.get('logradouro').value,
          numero: this.formEndereco.get('numero').value,
          complemento: this.formEndereco.get('complemento').value,
          bairro: this.formEndereco.get('bairro').value,
          localidade: this.formEndereco.get('localidade').value,
          uf: this.formEndereco.get('uf').value,
          cep: this.formEndereco.get('cep').value,
        },
        banco: {
          codigoBanco: this.formDadosBancarios.get('codigoBanco').value,
          codigoAgencia: this.formDadosBancarios.get('codigoAgencia').value,
          digitoAgencia: this.formDadosBancarios.get('digitoAgencia').value,
          numeroConta: this.formDadosBancarios.get('numeroConta').value,
          digitoConta: this.formDadosBancarios.get('digitoConta').value,
        }
      };
      console.log('payload => ', payload);

      return payload;
    } else {
      return null;
    }
  }

  next() {
    console.log('step >> ', this.step);
    
    if (this.step === 0) {
      // ENDEREÇO
      this.preencheEndereco();
      this.step = 1;
    } else if (this.step === 1) {
      // DADOS BANCÁRIOS
      // VALIDA SE É PARAMETRO DE EP
      if (this.authResult.ep == true) {
        this.step = 2;
      } else {
        this.step = 3;
        this.proposta();
      }
      // this.preencheDadosBancarios();
    } else if (this.step === 2) {
      // GERAR PROPOSTA
      this.step = 3;
      this.proposta();
    }
  }

  preencheDadosBancarios() {

  }

  back() {
    if (this.step === 2) {
      this.step = 1;
    } else if (this.step === 1) {
      this.step = 0;
    } else {
      this.location.back();
    }
  }

  async proposta() {
    await this.appState.setLoading(true);
    const payload = this.getPayload();

    console.log('payload => ', payload);    

    this.credito.proposta(payload).then(results => {
      // console.log('results => ', results, new SDKResponse(results));
      this.appState.setResponseResult(new SDKResponse(results));
      this.router.navigate(['success']);
    }).catch(e => {
      // console.log('e => ', e);
      this.router.navigate(['error']);
      // this.router.navigate(['success']);
    }).finally(() => {
      this.appState.setLoading(false);
    });

    // get(environment.sdk_url, () => {

    // });
  }

  async changeCep(cep: string) {
    this.formEndereco.get('cep').setValue(cep);
    this.formEndereco.get('logradouro').setValue('');
    this.formEndereco.get('complemento').setValue('');
    this.formEndereco.get('bairro').setValue('');
    this.formEndereco.get('localidade').setValue('');
    this.formEndereco.get('uf').setValue('');
    this.formEndereco.markAsUntouched();
    this.formEndereco.enable();
    // this.formEndereco.markAsPending();
    // this.formEndereco.markAsDirty();

    if (cep.length < 8) {
      this.formEndereco.get('cep').setErrors({ cepInvalido: true });
    } else {
      this.cepService.getAddressByZipcode(cep).then(address => {
        // console.log(address);
        // console.log(this.formEndereco);
        if (address.erro) {
          this.formEndereco.get('cep').setErrors({ cepInvalido: true });
        } else {
          if (address.logradouro) {
            this.formEndereco.get('logradouro').setValue(address.logradouro);
            // this.formEndereco.get('logradouro').disable();
          }

          if (address.bairro) {
            this.formEndereco.get('bairro').setValue(address.bairro);
            // this.formEndereco.get('bairro').disable();
          }

          if (address.localidade) {
            this.formEndereco.get('localidade').setValue(address.localidade);
            // this.formEndereco.get('localidade').disable();
          }

          if (address.uf) {
            this.formEndereco.get('uf').setValue(address.uf);
            // this.formEndereco.get('uf').disable();
          }

          // this.formEndereco.markAllAsTouched();
        }
      })
    }
  }

}
